// extracted by mini-css-extract-plugin
module.exports = {"teamDesciption":"TeamsPresentation_teamDesciption__tB2x0"};